import React from 'react';
import { Progress } from 'antd';
import { SystemHealthSectionProps } from './types';
import { SECTION_TITLES, SYSTEM_HEALTH_LABELS } from './constants';
import {
  SectionCard,
  SectionHeader,
  SectionTitle,
  HealthRow,
  HealthLabelRow,
  HealthLabel,
  HealthValue,
} from './styles';

const SystemHealthSection: React.FC<SystemHealthSectionProps> = ({ systemHealth }) => {
  return (
    <SectionCard>
      <SectionHeader>
        <SectionTitle>{SECTION_TITLES.SYSTEM_HEALTH}</SectionTitle>
      </SectionHeader>

      <HealthRow>
        <HealthLabelRow>
          <HealthLabel>{SYSTEM_HEALTH_LABELS.SERVER_UPTIME}</HealthLabel>
          <HealthValue>{systemHealth.uptime}%</HealthValue>
        </HealthLabelRow>
        <Progress
          percent={systemHealth.uptime}
          showInfo={false}
          strokeColor="#48BB78"
          size="small"
        />
      </HealthRow>

      <HealthRow>
        <HealthLabelRow>
          <HealthLabel>{SYSTEM_HEALTH_LABELS.API_RESPONSE}</HealthLabel>
          <HealthValue>{systemHealth.apiResponse}ms</HealthValue>
        </HealthLabelRow>
        <Progress
          percent={Math.min(systemHealth.apiResponse / 5, 100)}
          showInfo={false}
          strokeColor="#2D6CCA"
          size="small"
        />
      </HealthRow>

      <HealthRow>
        <HealthLabelRow>
          <HealthLabel>{SYSTEM_HEALTH_LABELS.DATABASE}</HealthLabel>
          <HealthValue>{systemHealth.database}</HealthValue>
        </HealthLabelRow>
        <Progress
          percent={100}
          showInfo={false}
          strokeColor="#48BB78"
          size="small"
        />
      </HealthRow>
    </SectionCard>
  );
};

export default SystemHealthSection;
